// function jwtDecode(token: string): Record<string, any> {
//     return {
//         sub: "1234567890",
//         name: "John Doe",
//         iat: 1516239022
//     };
// }
import { jwtDecode } from 'jwt-decode';
export function decodeToken(token: string): Record<string, any> | null {
    try {
        // Check if token is valid before attempting to decode
        if (!token || token.trim() === '') {
            return null;
        }
        const decoded = jwtDecode(token) as Record<string, any>;
        return decoded;
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
}
